<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle fill="currentColor" cx="8" cy="8" r="8"/>
        <path d="M11.03 9.818 9.212 8l1.818-1.818a.571.571 0 0 0 0-.808l-.404-.404a.571.571 0 0 0-.808 0L8 6.788 6.182 4.97a.571.571 0 0 0-.808 0l-.404.404a.571.571 0 0 0 0 .808L6.788 8 4.97 9.818a.571.571 0 0 0 0 .808l.404.404a.571.571 0 0 0 .808 0L8 9.212l1.818 1.818a.571.571 0 0 0 .808 0l.404-.404a.571.571 0 0 0 0-.808z" fill="#646E82" fill-rule="nonzero"/>
    </g>
</svg>
